// Every training module the Training page can open, keyed by route moduleKey.
import { agentSetupModule } from './agentSetupTraining';
import { newAgentsModule } from './newAgentsTraining';
import { buyersTrainingModule } from './buyersTraining';
import { fastCapTrainingModule } from './fastCapTraining';
import { aiAgentsModule } from './aiAgentsTraining';
import { resiSetupModule } from './resiSetupTraining';
import { howToUseResiModule } from './howToUseResiTraining';
import { teamLeadCertModule } from './teamLeadCertTraining';
import { leadGenModule, openHousesModule, youtubeModule, farmingModule, leadMagnetsModule, facebookGroupsModule, referralsReviewsModule, expiredsModule, sellersListingsModule } from './knowledgeBase';

export const TRAINING_MODULES = { agentSetup: agentSetupModule, aiAgents: aiAgentsModule, newAgents: newAgentsModule, buyers: buyersTrainingModule, fastcap: fastCapTrainingModule, leadGeneration: leadGenModule, openHouses: openHousesModule, youtube: youtubeModule, farming: farmingModule, leadMagnets: leadMagnetsModule, facebookGroups: facebookGroupsModule, referrals: referralsReviewsModule, expireds: expiredsModule, sellersListings: sellersListingsModule, resiSetup: resiSetupModule, teamLeadCert: teamLeadCertModule, howToUseResi: howToUseResiModule };

// Firebase RTDB keys cannot contain . # $ / [ ] and must not be empty.
export const isValidDbKey = (k) => typeof k === 'string' && k.length > 0 && !/[.#$/[\]]/.test(k);

// Index of the step to open: the saved position if it still exists, else the first unfinished step.
export function resumeIndex(allSteps, progress = {}, lastStepId = null) {
  if (lastStepId) {
    const i = allSteps.findIndex((s) => s.id === lastStepId);
    if (i !== -1) return i;
  }
  const firstOpen = allSteps.findIndex((s) => !progress[s.id]);
  return firstOpen === -1 ? Math.max(allSteps.length - 1, 0) : firstOpen;
}
